// extracted by mini-css-extract-plugin
export var gif = "_ip-0";